import classNames from 'classnames';
import React from 'react';

import Slides from 'common/components/RewindModal/Slides';
import {
  SEIGNEUR_DES_NOTES,
  IMG_STILL_AVAILABLE
} from 'common/configuration/constants';

import styles from '../styles.module.scss';
import BottomActions from './component/BottomActions';

type ScreenConclusionGlobalProps = {
  onNext: () => void;
  isLastStep: boolean;
};

const ScreenConclusionGlobal = ({
  onNext,
  isLastStep
}: ScreenConclusionGlobalProps) => {
  const title = 'Un Flashback signé par tous les spectateurs AlloCiné.';
  const subtitle = 'Partagez-le, comme on partage un bon film.';
  const noteText =
    "Faites vous aussi parti de l'histoire, notez dès maintenant vos films et séries sur AlloCiné.";

  return (
    <Slides>
      <div className={classNames(styles.contentLayout, styles.centeredLayout)}>
        <h2 className={styles.slideTitle}>{title}</h2>
        <h3 className={styles.slideText}>{subtitle}</h3>

        <div className={styles.conclusionGlobalContent}>
          <div className={styles.conclusionGlobalNoteSection}>
            <img
              src={SEIGNEUR_DES_NOTES}
              alt="Seigneur des notes"
              className={styles.conclusionGlobalNoteImage}
            />
            <p className={styles.conclusionGlobalNoteText}>{noteText}</p>
          </div>

          <div className={styles.conclusionGlobalStillAvailable}>
            <img
              src={IMG_STILL_AVAILABLE}
              alt="Still available"
              className={styles.conclusionGlobalStillAvailableImage}
            />
          </div>
        </div>
      </div>
      <BottomActions
        showShare={false}
        showNext={!isLastStep}
        onNextClick={onNext}
      />
    </Slides>
  );
};

export default ScreenConclusionGlobal;
